import React from "react";
import { Row, Tabs, Tab, Card, Col } from "react-bootstrap";
import { currencyFormat } from './../../Common/Common';
import noRecord from './../../../assets/img/no-record.png';

class SubscriptionInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: false,
            monthData: [],
            yearData: [],
            productID: '',
            productName: this.props.getUserData().productName,
            planId: '',
        }
    }
    componentWillMount() {
        let priceId = localStorage.getItem("price")
        this.setState({ monthData: this.props.monthData, yearData: this.props.yearData, planId: priceId });

        this.props.monthData.filter((monthData) => {
            Object.keys(monthData).forEach((v) => {
                if (v == 'price') {
                    let price = monthData[v].price + ''
                    if (price === priceId) {
                        this.updateUserData(monthData);
                        localStorage.setItem("interval", monthData[v].recurring.interval);

                    }
                }
            })
        });
        this.props.yearData.filter((yearData) => {
            Object.keys(yearData).forEach((v) => {
                if (v == 'price') {
                    let price = yearData[v].price + ''
                    if (price === priceId) {
                        this.updateUserData(yearData);
                        localStorage.setItem("interval", yearData[v].recurring.interval);

                    }
                }
            })
        })
    }
    /**
   * @desc update user data
   * @param {*} data 
   */
    updateUserData(data) {
        this.props.updateUserData("price", data.price.price);
        this.props.updateUserData("productName", data.name);
        this.props.updateUserData("amount", data.price.unit_amount);
        this.props.updateUserData("interval", data.price.recurring.interval);
        this.setState({ productName: data.name })
    }
    render() {

        return (
            <>
                <div className="step-content container-custom pricing">

                    <Tabs defaultActiveKey={localStorage.getItem("interval") == undefined || localStorage.getItem("interval") === "month" ? "monthly" : "annually"} id="uncontrolled-tab-example" className="subscription-tabs">
                        <Tab eventKey="monthly" title="Monthly">
                            {this.state.monthData.length > 0 ?
                                <>
                                    <Row><h4 className="col">Select Your Plan</h4></Row>
                                    <Row>
                                        {this.state.monthData.map(monthData => {
                                            if (monthData.price.isActive && monthData.isActive) {
                                                let description = "<div>" + monthData.description + "</div>";

                                                return (

                                                    <Col lg={3} md={6} sm={6} className={`plan-scheme ${this.state.planId === monthData.price.price ? "active-plan" : ''}`} onClick={() => {
                                                        this.setState({ planId: monthData.price.price }); this.updateUserData(monthData); localStorage.setItem("price", monthData.price.price); localStorage.setItem("interval", monthData.price.recurring.interval)
                                                    }}>
                                                        <Card className="transaction-single">
                                                            <Card.Body>
                                                                <h4>{monthData.name}</h4>
                                                                <p className="plan-price">{currencyFormat(monthData.price.unit_amount)}/mo.</p>
                                                                <div className="plan-desc">
                                                                    <label>Description</label>
                                                                    <p className="plan-text" dangerouslySetInnerHTML={{ __html: monthData.description }}></p>
                                                                    <div className="more-plan-text" dangerouslySetInnerHTML={{ __html: description }}>

                                                                    </div>
                                                                </div>
                                                            </Card.Body>
                                                        </Card>

                                                    </Col>
                                                )
                                            }
                                        })}

                                    </Row>
                                </> :
                                <div className="no-transaction no-record no-datatable">
                                    <div className="no-transaction-inner">
                                        <img src={noRecord} alt="no record" />
                                        <p>No Plans Found</p>
                                    </div>
                                </div>
                            }
                        </Tab>
                        <Tab eventKey="annually" title="Annually">
                            {this.state.yearData.length > 0 ? <>
                                <Row><h4 className="col">Select Your Plan</h4></Row>
                                <Row>
                                    {this.state.yearData.map(yearData => {
                                        if (yearData.price.isActive && yearData.isActive) {
                                            let description = "<div>" + yearData.description + "</div>";

                                            return (

                                                <Col lg={3} md={6} sm={6} className={`plan-scheme ${this.state.planId === yearData.price.price ? "active-plan" : ''}`} onClick={() => { this.setState({ planId: yearData.price.price }); this.updateUserData(yearData); localStorage.setItem("price", yearData.price.price); localStorage.setItem("interval", yearData.price.recurring.interval) }}>
                                                    <Card className="transaction-single">
                                                        <Card.Body>
                                                            <h4>{yearData.name}</h4>
                                                            <p className="plan-price">{currencyFormat(yearData.price.unit_amount)}/yr.</p>
                                                            <div className="plan-desc">
                                                                <label>Description</label>
                                                                <p className="plan-text" dangerouslySetInnerHTML={{ __html: yearData.description }}></p>
                                                                <div className="more-plan-text" dangerouslySetInnerHTML={{ __html: description }}>

                                                                </div>
                                                            </div>
                                                        </Card.Body>
                                                    </Card>

                                                </Col>
                                            )
                                        }
                                    })}
                                </Row></> :
                                <div className="no-transaction no-record no-datatable">
                                    <div className="no-transaction-inner">
                                        <img src={noRecord} alt="no record" />
                                        <p>No Plans Found</p>
                                    </div>
                                </div>}
                        </Tab>
                    </Tabs>

                </div>
            </>
        );
    }
}


export default (SubscriptionInfo)